import Cookies from 'js-cookie';
import { isEmpty } from 'lodash';

import apiGet from '@api/api-get';
import apiPost from '@api/api-post';
import apiDelete from '@api/api-delete';
import apiPut from '@api/api-put';

interface IResult {
  code: number,
  msg: string,
  result: any,
}

interface IIndustryParam {
  industry: number | string,
}

const ResearchService = {
  // ------ 产业链分布 ------
  chainDistribution: async (param: IIndustryParam) => {
    const data: IResult | null = await apiGet('/mg/market/industry_detail/research/chain_distribution', param);
    if (!data) return [];
    return (data as IResult).result;
  },
  // ------ 典型职位 ------
  typicalJobs: async (param: IIndustryParam) => {
    const data: IResult | null = await apiGet('/mg/market/industry_detail/research/typical_jobs', param);
    if (!data) return [];
    return (data as IResult).result;
  },
  // 行业研报
  report: async () => {
    const data: IResult | null = await apiGet('/mg/payrolls/market/sample/reports');
    if (!data) return [];
    return (data as IResult).result;
  },
  // 公司性质分布
  natureDistribution: async (param: IIndustryParam) => {
    const data: IResult | null =
      await apiGet('/mg/market/industry_detail/research/company/nature_distribution', param);
    if (!data) return [];
    return (data as IResult).result;
  },
  // 公司规模分布
  scaleDistribution: async (param: IIndustryParam) => {
    const data: IResult | null =
      await apiGet('/mg/market/industry_detail/research/company/scale_distribution', param);
    if (!data) return [];
    return (data as IResult).result;
  },
  // 市场规模
  marketSize: async (param: IIndustryParam) => {
    const data: IResult | null =
      await apiGet('/mg/market/industry_detail/research/market_size', param);
    if (!data) return [];
    return (data as IResult).result;
  },
  // 公司总部分布
  locationDistribution: async (param: any) => {
    const data: IResult | null =
      await apiGet('/mg/market/industry_detail/research/company/location_distribution', param);
    if (!data) return [];
    return (data as IResult).result;
  },
  // 行业列表 + 描述
  homeIndustry: async () => {
    const data: IResult | null = await apiGet('/mg/market/v2/industry/list');
    if (!data) return [];
    return (data as IResult).result;
  },
};

export default ResearchService;
